import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import { Notification, NotificationType, Box } from 'edenred-ui';

import { INotification } from '@epi-models/components/Notifier';

import { getNotifications } from '../../selectors/overlays';
import * as overlaysActions from '../../actions/overlays';

import { NotifierContainer } from './Notifier.styles';

interface NotifierProps {
  hideNotification: (uid: string) => void;
  notifications: INotification[];
}

function Notifier({ hideNotification, notifications }: NotifierProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (notifications.length > 0) {
      notifications.forEach(notification => {
        setTimeout(() => {
          hideNotification(notification.uid);
        }, 5000);
      });
    }
  }, [notifications]);

  return (
    <NotifierContainer>
      {notifications.map(notification => (
        <Box key={notification.uid} mb={1}>
          <Notification
            key={notification.uid}
            type={
              notification.level === 'warning'
                ? NotificationType.Important
                : notification.level
            }
            text={t(notification.message)}
            onClose={() => hideNotification(notification.uid)}
          />
        </Box>
      ))}
    </NotifierContainer>
  );
}

const mapStateToProps = state => ({
  notifications: getNotifications(state)
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(overlaysActions, dispatch);

const ConnectedNotifier = connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifier);

export { ConnectedNotifier as Notifier };
